import { FETCH_BANKS_EXCHRATES_LIST } from 'actionTypes';
import { successAction } from 'utils/redux';
import createReducer from './createReducer';

export const initialState = {
  banksExchrates: [],
};

const banks = createReducer(initialState, {
  [successAction(FETCH_BANKS_EXCHRATES_LIST)]: (state, action) => ({
    ...state,
    banksExchrates: action.payload,
  }),
});

export default banks;
